<form class="form" [formGroup]="activityForm" (ngSubmit)="save()">
    <form-group title="{{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.TITLE' | translate }}" isLast="true">
      <field-holder>
        <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.ACTIVITY_DESCRIPTION'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="activityDescription" autocomplete="off" required></textarea>
            <mat-error *ngIf="activityForm.get('activityDescription').hasError('required')">
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.ACTIVITY_DESCRIPTION_ERROR' | translate }}
            </mat-error>
        </mat-form-field>
      </field-holder>
      <field-holder>
        <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.ACTIVITY_GOAL'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="activityGoal" autocomplete="off" required></textarea>
            <mat-error *ngIf="activityForm.get('activityGoal').hasError('required')">
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.ACTIVITY_GOAL_ERROR' | translate }}
            </mat-error>
          </mat-form-field>
      </field-holder>
      <field-holder>
        <mat-form-field appearance="outline">
            <mat-label>
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.EXPECTED_OUTCOME'| translate}}
            </mat-label>
            <textarea matInput type="text" formControlName="expectedOutcome" autocomplete="off" required></textarea>
            <mat-error *ngIf="activityForm.get('expectedOutcome').hasError('required')">
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.EXPECTED_OUTCOME_ERROR' | translate }}
            </mat-error>
          </mat-form-field>
      </field-holder>
      <field-holder kind="2-cols">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REALIZATION_PERIOD_FROM' | translate }}</mat-label>
          <input matInput [matDatepicker]="realizationPeriodFrom"
          formControlName="realizationPeriodFrom" autocomplete="off" [max]="maxDate" required />
          <mat-datepicker-toggle matSuffix [for]="realizationPeriodFrom"></mat-datepicker-toggle>
          <mat-datepicker #realizationPeriodFrom></mat-datepicker>
          <mat-error *ngIf="activityForm.get('realizationPeriodFrom').hasError('required')">
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REALIZATION_PERIOD_FROM_ERROR' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REALIZATION_PERIOD_TO' | translate }}</mat-label>
          <input matInput [matDatepicker]="realizationPeriodTo"
            formControlName="realizationPeriodTo" autocomplete="off" [min]="minToDate" [max]="maxDate" required />
          <mat-datepicker-toggle matSuffix [for]="realizationPeriodTo"></mat-datepicker-toggle>
          <mat-datepicker #realizationPeriodTo ></mat-datepicker>
          <mat-error *ngIf="activityForm.get('realizationPeriodTo').hasError('required')">
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REALIZATION_PERIOD_TO_ERROR' | translate }}
          </mat-error>
        </mat-form-field>
      </field-holder>
      <field-holder>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REVIEW_DEADLINE' | translate }}</mat-label>
          <input matInput [matDatepicker]="reviewDeadline"
          formControlName="reviewDeadline" autocomplete="off" [max]="maxDate" required />
          <mat-datepicker-toggle matSuffix [for]="reviewDeadline"></mat-datepicker-toggle>
          <mat-datepicker #reviewDeadline></mat-datepicker>
          <mat-error *ngIf="activityForm.get('reviewDeadline').hasError('required')">
              {{ 'SERVICE_PROVIDERS.INDIVIDUAL_SERVICE_PLAN.STEP_02.ACTIVITIES.REVIEW_DEADLINE_ERROR' | translate }}
          </mat-error>
        </mat-form-field>
      </field-holder>
    </form-group>
  
    <form-footer>
      <button mat-stroked-button color="primary" type="button" (click)="closeDialog()"
        class="form-footer__button form-footer__button--secondary">
        {{ 'GLOBAL.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit" class="form-footer__button form-footer__button--primary"
        [disabled]="activityForm.invalid">
        {{ 'GLOBAL.SAVE' | translate }}
      </button>
    </form-footer>
</form>